import { MatDialog } from "@angular/material/dialog";
import { Component, OnDestroy,  } from "@angular/core";
import { InboundStockTooltipComponent } from "./inbound-stock-tooltip/inbound-stock-tooltip.component";
import { WarehousesTooltipComponent } from "../warehouses-tooltip/warehouses-tooltip.component";
import { Subject } from "rxjs";

@Component({
  selector: "app-avg-price-tooltip-cell-renderer",
  templateUrl: "./avg-price-tooltip-cell-renderer.component.html",
  styleUrls: ["./avg-price-tooltip-cell-renderer.component.scss"],
})
export class AvgPriceTooltipCellRendererComponent implements OnDestroy{
  params;
  dialogRef;
  isInboundQty:boolean=false;
  duplicateSkus:any;
  private destroy$ = new Subject<void>();
  constructor(private dialog: MatDialog) {}

  agInit(params: any): void {
    this.params = params;
    this.isInboundQty =this.params.column.colId  === "InboundQty";
    this.duplicateSkus =  `Product has ASIN with duplicate SKUs`;
  }

  
  openDialog(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    this.dialogRef = this.dialog.open(WarehousesTooltipComponent, {
      hasBackdrop: false,
      position: {
        left: targetPosision.right + 10 + "px",
        top: targetPosision.top - 30 + "px",
      },
      width: "200",
      data: this.params.data.ItemId
    });
  }

  openInboundDialog(e: MouseEvent) {
    e.stopPropagation();
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    this.dialogRef = this.dialog.open(InboundStockTooltipComponent, {
      position: {
        left: targetPosision.right + 10 + "px",
        top: targetPosision.top - 30 + "px",
      },
      data: this.params.data.ItemId,
      backdropClass: ["cdk-overlay-transparent-backdrop", "arrow-backdrop"],
    });
  }

  closeDialog(e) {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
